import { Switch, Route, useRouteMatch } from "react-router-dom";
import DashBoardScreen from "../screens/DashBoardScreens/DashBoardScreen";
import AnalyticScreen from "../screens/DashBoardScreens/AnalyticScreen";
import routes from "./URL";
export default function gallery_image_routes() {
    return (
        <Switch>
            {/* <Route
                exact
                path={routes.admin.floors.create}
                component={CreateFloorScreen}
            />*/}

            <Route
                exact
                path={routes.admin.dashboard.analytics(":hotelSlug")}
                component={AnalyticScreen}
            />
            {/*
            <Route
                exact
                path={routes.admin.floors.createTable(":id")}
                component={CreateTableScreen}
            />
            <Route
                exact
                path={routes.admin.floors.show(":id")}
                component={FloorDetailScreen}
            /> */}
            <Route
                exact
                path={routes.admin.dashboard.root(":hotelSlug")}
                component={AnalyticScreen}
            />

            <Route exact path={routes.admin.root} component={AnalyticScreen} />
        </Switch>
    );
}
